import { forceVisible } from 'react-lazyload';
import { useLocation } from 'react-router-dom';
// Store
import { useAppDispatch, useAppSelector } from 'app/hooks/useStore';
// Actions
import PageActions from 'app/store/page/page.actions';
// Selectors
import { selectWorkspaceType } from 'app/store/ui/uiSelectors';
import { selectFilter } from 'app/store/page/page.selectors';
// 
import { Switch } from 'app/components/Mui';
// i18next
import { useTranslation } from 'react-i18next';
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';

const HaveDuplicateInWorkspace = () => {
  const { t } = useTranslation();

  const { pathname } = useLocation<{ pathname: string }>();

  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const filter = useAppSelector(selectFilter);
  // ToDO
  const workspaceType = useAppSelector(selectWorkspaceType);

  const handleChange = (_:any, checked:boolean) => {
    dispatch(PageActions.setFilter('haveDuplicateInWorkspace', checked));
    dispatch(PagesToolbarActions.clearSelectedPages());
    forceVisible();
  }

  const isWorkspacePath = pathname.includes('/workspace');
  const label = isWorkspacePath ? t('pages.workspace.duplicatesOnly') : t('pages.files.haveDuplicateInWorkspace');

  if ( workspaceType !== 'pages' ) return null;
  return (
    <Switch
      sx={{ pt: 0 }}
      label={label} value={filter.haveDuplicateInWorkspace} name="haveDuplicateInWorkspace"
      onChange={handleChange}
    />
  )
}

export default HaveDuplicateInWorkspace;
